import { Record, List, Map, fromJS } from 'immutable'
import { Avatars } from 'app/modules/user/models'

export function parseEndUser(data) {
  const { attributes, tags, avatars, ...rest } = data
  return EndUser({
    avatars: Avatars(avatars),
    attributes: fromJS(attributes),
    tags: List(tags),
    ...rest,
  })
}

export const EndUser = Record({
  avatars: Avatars(),
  id: undefined,
  orgId: undefined,
  customerId: undefined,
  status: undefined,
  name: undefined,
  alias: null,
  email: undefined,
  phone: null,
  locale: null,
  timeZone: null,
  avatarUrl: null,
  primaryIdentity: undefined,
  createdAt: undefined,
  externalId: undefined,
  socialProfile: null,
  attributes: Map(),
  tags: List(),
  happiness: undefined,
  type: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/models.js